import {isDevelopment} from './general'

/**
 * Simulates JWT claims for local development without Azure AD
 * This allows testing different user roles locally
 */
export const getSimulatedJWTClaims = () => {
  // Only simulate in development mode
  if (!isDevelopment) {
    return null
  }

  const localUserRoles = process.env.LOCAL_USER_ROLES
  if (!localUserRoles) {
    return null
  }

  // Return simulated JWT claims matching Azure AD B2C structure
  return {
    extension_Roles: localUserRoles,
  }
}

/**
 * Gets user roles from either real JWT claims or simulated local roles
 * @param jwtClaims - Real JWT claims from Azure AD (when available)
 * @returns Role string (comma-separated if multiple roles)
 */
export const getUserRoles = (jwtClaims?: Record<string, string>): string => {
  // In development, prioritize simulated claims over real JWT claims
  if (isDevelopment) {
    const simulatedClaims = getSimulatedJWTClaims()
    if (simulatedClaims?.extension_Roles) {
      return simulatedClaims.extension_Roles
    }
  }

  // Fall back to real JWT claims
  if (jwtClaims?.extension_Roles) {
    return jwtClaims.extension_Roles
  }

  // Final fallback
  return ''
}
